import { useEffect, useRef, useCallback } from 'react';
import { getSocket } from '@utils/socket';
import { useAuth } from '@context/AuthContext';
import { usePublicConfig } from '@context/PublicConfigContext';

export const useSocket = () => {
  const { token } = useAuth();
  const { ready: publicConfigReady } = usePublicConfig();
  const socketRef = useRef(null);

  useEffect(() => {
    if (token && publicConfigReady) {
      socketRef.current = getSocket(token);
    }
    return () => {
      socketRef.current = null;
    };
  }, [token, publicConfigReady]);

  const on = useCallback((event, handler) => {
    const socket = socketRef.current;
    if (!socket) return () => {};
    socket.on(event, handler);
    return () => socket.off(event, handler);
  }, []);

  return { socket: socketRef.current, on };
};
